'use client';
import React from 'react';
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from 'recharts';
import { CATEGORY_DEFICIENCY_DATA } from './analyticsData';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl border shadow-elevated p-3 text-xs" style={{ borderColor: 'hsl(var(--border))' }}>
      <p className="font-semibold mb-1">{payload[0]?.payload?.label}</p>
      <p className="text-muted">Deficiencies: <span className="font-bold text-foreground tabular-nums">{payload[0]?.value}</span></p>
      <p className="text-muted">Fleet exposure: <span className="font-bold text-foreground tabular-nums">{payload[0]?.payload?.pct}%</span></p>
    </div>
  );
};

const BAR_COLORS = [
  'hsl(355, 75%, 52%)',
  'hsl(22, 85%, 50%)',
  'hsl(38, 90%, 48%)',
  'hsl(44, 85%, 48%)',
  'hsl(210, 70%, 48%)',
  'hsl(218, 60%, 42%)',
  'hsl(218, 50%, 50%)',
  'hsl(218, 45%, 55%)',
  'hsl(218, 40%, 60%)',
  'hsl(218, 35%, 65%)',
];

export default function CategoryDeficiencyChart() {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <BarChart data={CATEGORY_DEFICIENCY_DATA} margin={{ top: 4, right: 4, left: -16, bottom: 0 }} layout="vertical">
        <CartesianGrid stroke="hsl(214, 20%, 88%)" strokeDasharray="3 3" horizontal={false} />
        <XAxis type="number" tick={{ fontSize: 11, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} />
        <YAxis dataKey="category" type="category" tick={{ fontSize: 11, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} width={36} />
        <Tooltip content={<CustomTooltip />} cursor={{ fill: 'hsl(218 70% 22% / 0.04)' }} />
        <Bar dataKey="deficiencies" radius={[0, 4, 4, 0]} maxBarSize={18}>
          {CATEGORY_DEFICIENCY_DATA.map((_, i) => (
            <Cell key={`cell-cat-${i}`} fill={BAR_COLORS[i] || 'hsl(218, 60%, 42%)'} />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
}